import { render, staticRenderFns } from "./SoftPosRegistrationModal.vue?vue&type=template&id=4fedd324&scoped=true"
import script from "./SoftPosRegistrationModal.vue?vue&type=script&lang=js"
export * from "./SoftPosRegistrationModal.vue?vue&type=script&lang=js"
import style0 from "./SoftPosRegistrationModal.vue?vue&type=style&index=0&id=4fedd324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fedd324",
  null
  
)

export default component.exports